import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {COMMAND_PRIORITY_LOW, PASTE_COMMAND, PasteCommandType} from 'lexical';
import {useEffect} from 'react';

export const EmptyLinePastePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const removePasteListener = editor.registerCommand(
      PASTE_COMMAND,
      (event: PasteCommandType) => {
        try {
          const clipboardData = (event as any).clipboardData;
          if (!clipboardData) {
            return false;
          }

          const html = clipboardData.getData('text/html');
          if (!html) {
            return false;
          }

          // Check if the HTML contains empty divs with br tags
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const emptyDivs = tempDiv.querySelectorAll('div');
          let hasEmptyLines = false;

          emptyDivs.forEach((div) => {
            const children = Array.from(div.childNodes);
            const hasOnlyBr =
              children.length === 1 &&
              children[0].nodeType === Node.ELEMENT_NODE &&
              (children[0] as Element).tagName === 'BR';

            if (hasOnlyBr) {
              hasEmptyLines = true;
            }
          });

          if (hasEmptyLines) {
            // Process the HTML to convert empty divs to paragraphs
            const processedHtml = processHtmlForEmptyLines(html);

            // Replace the clipboard data with processed HTML
            const originalGetData = clipboardData.getData;
            clipboardData.getData = (type: string) => {
              if (type === 'text/html') {
                return processedHtml;
              }
              return originalGetData.call(clipboardData, type);
            };
          }

          return false; // Let other handlers run
        } catch {
          return false;
        }
      },
      COMMAND_PRIORITY_LOW
    );

    return () => {
      removePasteListener();
    };
  }, [editor]);

  // Helper function to process HTML and convert empty divs with br tags to paragraphs
  const processHtmlForEmptyLines = (html: string): string => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Find all div elements that contain only a br tag
    const emptyDivs = tempDiv.querySelectorAll('div');
    emptyDivs.forEach((div) => {
      const children = Array.from(div.childNodes);
      const hasOnlyBr =
        children.length === 1 &&
        children[0].nodeType === Node.ELEMENT_NODE &&
        (children[0] as Element).tagName === 'BR';

      if (hasOnlyBr) {
        // Replace the div with a paragraph containing a line break
        const paragraph = document.createElement('p');
        paragraph.innerHTML = '<br>';
        div.parentNode?.replaceChild(paragraph, div);
      }
    });

    return tempDiv.innerHTML;
  };

  return null;
};
